/* ============ SNAKE DEPT — theme.js (Shopify, compatible con el editor de temas) ============ */
(() => {
"use strict";
const $  = (s, c = document) => c.querySelector(s);
const $$ = (s, c = document) => [...c.querySelectorAll(s)];
const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
const isTouch = matchMedia("(hover:none),(pointer:coarse)").matches;
const CFG = window.SNAKE || { routes: {}, freeShip: 60, moneyFormat: "{{amount}}€" };

/* Modo editor de Shopify: sin animaciones de entrada — nada puede quedarse invisible */
const designMode = !!(window.Shopify && window.Shopify.designMode);
if (designMode) document.documentElement.classList.add("design-mode");

/* Formatea céntimos según el money_format de la tienda (soporta todos los placeholders de Shopify) */
function money(cents) {
  const fmt = CFG.moneyFormat || "{{amount}}€";
  function withDelimiters(num, precision, thousands, decimal) {
    if (isNaN(num) || num == null) num = 0;
    const fixed = (num / 100).toFixed(precision);
    const parts = fixed.split(".");
    const intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    const decPart = parts[1] ? decimal + parts[1] : "";
    return intPart + decPart;
  }
  return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, name) => {
    switch (name) {
      case "amount": return withDelimiters(cents, 2, ",", ".");
      case "amount_no_decimals": return withDelimiters(cents, 0, ",", ".");
      case "amount_with_comma_separator": return withDelimiters(cents, 2, ".", ",");
      case "amount_no_decimals_with_comma_separator": return withDelimiters(cents, 0, ".", ",");
      case "amount_with_space_separator": return withDelimiters(cents, 2, " ", ",");
      case "amount_no_decimals_with_space_separator": return withDelimiters(cents, 0, " ", "");
      case "amount_with_apostrophe_separator": return withDelimiters(cents, 2, "'", ".");
      default: return withDelimiters(cents, 2, ",", ".");
    }
  }).replace(/<[^>]+>/g, "").trim();
}

document.body.classList.add("is-loaded");

/* marca un elemento como ya inicializado (evita dobles bindings al re-renderizar) */
function bindOnce(el, key) {
  if (!el || el.dataset[key]) return false;
  el.dataset[key] = "1";
  return true;
}

/* ---------- TOAST (elemento del layout, nunca se re-renderiza) ---------- */
const toastEl = $("#toast");
let toastTimer;
function toast(msg) {
  if (!toastEl) return;
  toastEl.textContent = msg;
  toastEl.classList.add("is-show");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toastEl.classList.remove("is-show"), 2600);
}

/* ---------- CURSOR ---------- */
(function initCursor() {
  const cursor = $("#cursor");
  if (!cursor || isTouch || !bindOnce(cursor, "jsBound")) return;
  const label = $("#cursorLabel");
  let cx = -100, cy = -100, tx = cx, ty = cy;
  addEventListener("mousemove", e => { tx = e.clientX; ty = e.clientY; });
  (function loop() {
    cx += (tx - cx) * 0.22; cy += (ty - cy) * 0.22;
    cursor.style.transform = `translate(${cx}px,${cy}px) translate(-50%,-50%)`;
    requestAnimationFrame(loop);
  })();
  document.addEventListener("mouseover", e => {
    const t = e.target.closest("[data-cursor],a,button");
    if (t) { cursor.classList.add("is-big"); label.textContent = t.dataset ? (t.dataset.cursor || "") : ""; }
    else cursor.classList.remove("is-big");
  });
})();

/* ---------- REVEALS (observer global, re-aplicable) ---------- */
const io = new IntersectionObserver(es => es.forEach(e => {
  if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
}), { threshold: 0.15 });

function initReveals(root) {
  $$(".reveal", root).forEach(el => {
    if (designMode) { el.classList.add("is-in"); return; }
    if (!el.classList.contains("is-in")) io.observe(el);
  });
}

/* ---------- SCRAMBLE + MAGNETIC ---------- */
const CHARS = "SNAKEDPT#@%&";
function initScramble(root) {
  $$("[data-scramble]", root).forEach(el => {
    if (!bindOnce(el, "scrBound")) return;
    const original = el.textContent; let iv = null;
    el.addEventListener("mouseenter", () => {
      let i = 0; clearInterval(iv);
      iv = setInterval(() => {
        el.textContent = original.split("").map((ch, j) => j < i ? ch : CHARS[Math.floor(Math.random()*CHARS.length)]).join("");
        if (i++ > original.length) { clearInterval(iv); el.textContent = original; }
      }, 32);
    });
  });
}
function initMagnetic(root) {
  if (isTouch) return;
  $$("[data-magnetic]", root).forEach(btn => {
    if (!bindOnce(btn, "magBound")) return;
    btn.addEventListener("mousemove", e => {
      const r = btn.getBoundingClientRect();
      btn.style.transform = `translate(${(e.clientX-r.left-r.width/2)*0.28}px,${(e.clientY-r.top-r.height/2)*0.28}px)`;
    });
    btn.addEventListener("mouseleave", () => { btn.style.transform = ""; });
  });
}

/* ---------- NAV SOLIDA (consulta el DOM en vivo) ---------- */
addEventListener("scroll", () => {
  const nav = $("#nav");
  if (nav) nav.classList.toggle("is-solid", scrollY > 40 || !$("#hero"));
}, { passive: true });

/* ---------- HERO SLIDESHOW (re-iniciable) ---------- */
let heroTimer = null;
function initHero() {
  clearInterval(heroTimer);
  const slides = $$(".hero__slide");
  const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (slides.length > 1 && !designMode && !reducedMotion) {
    let i = slides.findIndex(s => s.classList.contains("is-active"));
    if (i < 0) { i = 0; slides[0].classList.add("is-active"); }
    heroTimer = setInterval(() => {
      slides[i].classList.remove("is-active");
      i = (i + 1) % slides.length;
      slides[i].classList.add("is-active");
      const heroIdx = $("#heroIdx");
      if (heroIdx) heroIdx.textContent = String(i + 1).padStart(2, "0");
    }, 5200);
  }
  const t = $("#heroTitle");
  if (t && !isTouch && bindOnce(t, "parBound")) {
    addEventListener("mousemove", e => {
      const el = $("#heroTitle");
      if (el) el.style.transform = `translate(${(e.clientX/innerWidth-0.5)*18}px,${(e.clientY/innerHeight-0.5)*10}px)`;
    });
  }
}

/* ---------- COUNTDOWN (re-iniciable) ---------- */
let cdTimer = null;
function initCountdown() {
  clearInterval(cdTimer);
  const cd = $("[data-countdown]");
  if (!cd) return;
  const end = new Date(cd.dataset.countdown.replace(" ", "T"));
  if (isNaN(end)) return;
  const tick = () => {
    const box = $("[data-countdown]");
    if (!box) { clearInterval(cdTimer); return; }
    const sec = Math.max(0, Math.floor((end - Date.now()) / 1000));
    if (sec <= 0) {
      /* Drop terminado: sustituye la cuenta por el estado cerrado */
      const label = $("p", box);
      if (label) label.textContent = "DROP CERRADO";
      const timer = $(".timer", box);
      if (timer) timer.style.display = "none";
      clearInterval(cdTimer);
      return;
    }
    const set = (sel, v) => { const el = $(sel, box); if (el) el.textContent = String(v).padStart(2, "0"); };
    set("[data-d]", Math.floor(sec/86400));
    set("[data-h]", Math.floor(sec/3600)%24);
    set("[data-m]", Math.floor(sec/60)%60);
    set("[data-s]", sec%60);
  };
  tick(); cdTimer = setInterval(tick, 1000);
}

/* ---------- LOOKBOOK HORIZONTAL (consulta el DOM en vivo) ---------- */
function lookbookScroll() {
  const sec = $("#lookbook");
  if (!sec) return;
  const track = $("#lookTrack"), prog = $("#lookProg");
  if (!track) return;
  const r = sec.getBoundingClientRect();
  const total = r.height - innerHeight;
  if (total <= 0) return;
  const p = clamp(-r.top / total, 0, 1);
  const max = track.scrollWidth - innerWidth + innerWidth * 0.06;
  track.style.transform = `translateX(${-p * max}px)`;
  if (prog) prog.style.width = (p * 100) + "%";
}
addEventListener("scroll", lookbookScroll, { passive: true });
addEventListener("resize", lookbookScroll);

/* ---------- TEXTO QUE SE ENCIENDE PALABRA A PALABRA (manifiesto + nosotros) ---------- */
/* Soporta varias instancias: cualquier elemento con [data-reveal-text] */
let revealTexts = [];
function initManifesto() {
  revealTexts = [];
  $$("[data-reveal-text]").forEach(el => {
    if (!el.querySelector(".w")) {
      const custom = (el.dataset.venom || "serpiente,muda:,permiso,estabas").toLowerCase().split(",");
      const VENOM = new Set(custom.map(s => s.trim()));
      el.innerHTML = el.textContent.trim().split(/\s+/).map(w =>
        `<span class="w${VENOM.has(w.toLowerCase()) ? " is-venom" : ""}">${w}</span>`).join(" ");
    }
    const words = $$(".w", el);
    const wrap = el.closest(".manifesto");
    const line = wrap ? wrap.querySelector(".manifesto__snake path") : null;
    let len = 0;
    if (line) { len = line.getTotalLength(); line.style.strokeDasharray = len; line.style.strokeDashoffset = designMode ? 0 : len; }
    if (designMode) words.forEach(w => w.classList.add("is-on"));
    revealTexts.push({ el, words, line, len });
  });
  if (!designMode) revealScroll();
}
function revealScroll() {
  if (designMode || !revealTexts.length) return;
  revealTexts.forEach(rt => {
    const r = rt.el.getBoundingClientRect();
    /* progreso 0→1 desde que el texto entra por abajo hasta que sube ~su propia altura:
       queda completamente encendido mientras aún está cómodamente en pantalla */
    const p = clamp((innerHeight * 0.9 - r.top) / (r.height * 0.85 + innerHeight * 0.12), 0, 1);
    const n = Math.ceil(p * rt.words.length);
    rt.words.forEach((w, i) => w.classList.toggle("is-on", i < n));
    if (rt.line) rt.line.style.strokeDashoffset = rt.len * (1 - p);
  });
}
addEventListener("scroll", revealScroll, { passive: true });

/* ---------- CONTENIDO DE PÁGINA: enciende palabra a palabra conservando párrafos ---------- */
function wrapWords(el) {
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(node => {
    if (!node.nodeValue.trim()) return;
    const frag = document.createDocumentFragment();
    node.nodeValue.split(/(\s+)/).forEach(tok => {
      if (tok === "" ) return;
      if (/^\s+$/.test(tok)) { frag.appendChild(document.createTextNode(tok)); }
      else { const s = document.createElement("span"); s.className = "w"; s.textContent = tok; frag.appendChild(s); }
    });
    node.parentNode.replaceChild(frag, node);
  });
}
function initContentReveal() {
  $$("[data-reveal-content]").forEach(container => {
    if (container.dataset.revealReady) return;
    container.dataset.revealReady = "1";
    $$("h1,h2,h3,h4,h5,p,li,blockquote", container).forEach(block => {
      if (!block.textContent.trim() || block.querySelector(".w")) return;
      wrapWords(block);
      const words = $$(".w", block);
      if (!words.length) return;
      if (designMode) words.forEach(w => w.classList.add("is-on"));
      revealTexts.push({ el: block, words: words, line: null, len: 0 });
    });
  });
  if (!designMode) revealScroll();
}

/* ---------- PARALLAX (consulta el DOM en vivo) ---------- */
addEventListener("scroll", () => {
  if (designMode) return;
  $$("[data-parallax]").forEach(el => {
    const img = el.querySelector("img");
    if (!img) return;
    const r = el.getBoundingClientRect();
    img.style.transform = `scale(1.12) translateY(${(r.top + r.height/2 - innerHeight/2) * parseFloat(el.dataset.parallax)}px)`;
  });
}, { passive: true });

/* ---------- LIGHTBOX (elemento único, targets re-vinculables) ---------- */
let lbEl = null;
function getLightbox() {
  if (lbEl) return lbEl;
  lbEl = document.createElement("div");
  lbEl.className = "lightbox";
  lbEl.innerHTML = `<button class="lightbox__close" aria-label="Cerrar">✕</button><img alt="">`;
  document.body.appendChild(lbEl);
  lbEl.addEventListener("click", () => lbEl.classList.remove("is-open"));
  addEventListener("keydown", e => { if (e.key === "Escape") lbEl.classList.remove("is-open"); });
  return lbEl;
}
function initLightbox(root) {
  const targets = $$("[data-lightbox]", root);
  if (!targets.length) return;
  const lb = getLightbox();
  const img = $("img", lb);
  targets.forEach(el => {
    if (!bindOnce(el, "lbBound")) return;
    el.style.cursor = "zoom-in";
    el.addEventListener("click", () => {
      if (designMode) return; /* en el editor, el clic selecciona el bloque */
      const im = el.tagName === "IMG" ? el : $("img", el);
      if (im && im.src) { img.src = im.currentSrc || im.src; lb.classList.add("is-open"); }
    });
  });
}

/* ================================================================
   CARRITO AJAX (elementos del layout — no se re-renderizan)
================================================================ */
const FREE = (CFG.freeShip || 60) * 100;

function openCart() {
  const c = $("#cart"), o = $("#cartOverlay");
  if (c) { c.classList.add("is-open"); o && o.classList.add("is-open"); }
}
function closeCart() {
  const c = $("#cart"), o = $("#cartOverlay");
  if (c) { c.classList.remove("is-open"); o && o.classList.remove("is-open"); }
}

async function fetchCart() {
  try {
    const r = await fetch(CFG.routes.cart, { headers: { "Accept": "application/json" } });
    const cart = await r.json();
    renderCart(cart);
    return cart;
  } catch (e) { return null; }
}

function renderCart(cart) {
  if (!cart) return;
  $$("#cartCount, #cartCount2").forEach(el => {
    el.textContent = cart.item_count;
    el.classList.remove("is-bump"); void el.offsetWidth; el.classList.add("is-bump");
  });
  const totalEl = $("#cartTotal"); if (totalEl) totalEl.textContent = money(cart.total_price);
  const empty = $("#cartEmpty"); if (empty) empty.style.display = cart.item_count ? "none" : "block";

  const shipMsg = $("#shipMsg"), shipBar = $("#shipBar");
  if (shipMsg && shipBar) {
    if (cart.total_price >= FREE) { shipMsg.innerHTML = "<b>🎉 Envío gratis desbloqueado</b>"; shipBar.style.width = "100%"; }
    else { shipMsg.innerHTML = `Te faltan <b>${money(FREE - cart.total_price)}</b> para el envío gratis`; shipBar.style.width = (cart.total_price / FREE * 100) + "%"; }
  }

  const wrap = $("#cartItems");
  if (wrap) {
    $$(".cart-item", wrap).forEach(el => el.remove());
    cart.items.forEach((it, idx) => {
      const el = document.createElement("div");
      el.className = "cart-item";
      el.innerHTML = `
        <img src="${it.image ? it.image.replace(/(\.\w+)(\?|$)/, '_120x$1$2') : ''}" alt="">
        <div class="cart-item__info">
          <h5>${it.product_title}</h5>
          <p>TALLA ${it.variant_title || ''}</p>
          <div class="cart-item__qty">
            <button type="button" data-a="-">−</button><span>${it.quantity}</span><button type="button" data-a="+">+</button>
          </div>
        </div>
        <div class="cart-item__price">${money(it.final_line_price)}</div>`;
      el.querySelector('[data-a="-"]').addEventListener("click", () => changeLine(idx+1, it.quantity - 1));
      el.querySelector('[data-a="+"]').addEventListener("click", () => changeLine(idx+1, it.quantity + 1));
      wrap.appendChild(el);
    });
  }
}

async function changeLine(line, quantity) {
  try {
    const r = await fetch(CFG.routes.cart_change, {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line, quantity })
    });
    renderCart(await r.json());
  } catch (e) {}
}

async function addToCart(variantId, quantity = 1) {
  if (!variantId) { toast("Elige una talla"); return false; }
  try {
    const r = await fetch(CFG.routes.cart_add, {
      method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] })
    });
    if (!r.ok) { toast("No se pudo añadir — puede estar agotado"); return false; }
    await fetchCart();
    /* Píxeles de marketing (solo si están cargados) */
    try {
      if (window.fbq) fbq("track", "AddToCart", { content_ids: [String(variantId)], content_type: "product" });
      if (window.ttq) ttq.track("AddToCart", { content_id: String(variantId), content_type: "product" });
    } catch (err) {}
    return true;
  } catch (e) { toast("Error de conexión"); return false; }
}

function initCartUI() {
  const btn = $("#cartBtn");
  if (btn && bindOnce(btn, "cartBound")) btn.addEventListener("click", e => { e.preventDefault(); fetchCart().then(openCart); });
  const close = $("#cartClose");
  if (close && bindOnce(close, "cartBound")) close.addEventListener("click", closeCart);
  const ov = $("#cartOverlay");
  if (ov && bindOnce(ov, "cartBound")) ov.addEventListener("click", closeCart);
  const co = $("#checkoutBtn");
  if (co && bindOnce(co, "coBound")) co.addEventListener("click", () => {
    try {
      if (window.fbq) fbq("track", "InitiateCheckout");
      if (window.ttq) ttq.track("InitiateCheckout");
    } catch (err) {}
  });
}
addEventListener("keydown", e => { if (e.key === "Escape") closeCart(); });

/* ---------- TARJETAS DE PRODUCTO (re-vinculables) ---------- */
function initCards(root) {
  $$("[data-product-card]", root).forEach(card => {
    if (!bindOnce(card, "cardBound")) return;
    const sizes = $$("[data-card-sizes] button", card);
    sizes.forEach(b => b.addEventListener("click", () => {
      if (b.disabled) return;
      sizes.forEach(x => { x.classList.remove("is-active"); x.removeAttribute("data-selected"); });
      b.classList.add("is-active"); b.setAttribute("data-selected", "");
    }));
    const addBtn = $("[data-card-add]", card);
    if (addBtn) addBtn.addEventListener("click", async () => {
      const sel = $("[data-selected]", card) || sizes.find(b => !b.disabled);
      if (!sel) { toast("Sin stock"); return; }
      const ok = await addToCart(sel.dataset.variantId, 1);
      if (ok) { toast("AÑADIDO AL CARRITO"); setTimeout(openCart, 400); }
    });
  });
}

/* ---------- FICHA DE PRODUCTO (re-vinculable) ---------- */
function initPdp() {
  const pdp = $("#pdp");
  if (!pdp || !bindOnce(pdp, "pdpBound")) return;

  const main = $("#pdpMain");
  $$(".pdp__thumb", pdp).forEach(t => t.addEventListener("click", () => {
    if (main) {
      main.src = t.dataset.thumb;
      if (t.dataset.srcset) main.srcset = t.dataset.srcset;
    }
    $$(".pdp__thumb", pdp).forEach(x => x.classList.remove("is-active"));
    t.classList.add("is-active");
  }));

  const sizes = $$("#pdpSizes button", pdp);
  const sizeMsg = $("#pdpSizeMsg");
  const variantInput = $("#pdpVariantId");
  const qtyEl = $("#pdpQty"), qtyInput = $("#pdpQtyInput");
  let qty = 1, selBtn = null;

  const maxQty = () => Math.min(5, selBtn ? Math.max(1, parseInt(selBtn.dataset.qty) || 1) : 5);
  const syncQty = () => { qty = clamp(qty, 1, maxQty()); if (qtyEl) qtyEl.textContent = qty; if (qtyInput) qtyInput.value = qty; };

  /* Lista de espera: una talla agotada abre la captura de email con esa talla */
  const waitBox = $("#pdpWaitlist");
  function openWaitlist(sizeLabel) {
    if (!waitBox) return;
    waitBox.classList.add("is-open");
    const sizeEl = $("#pdpWaitSize");
    if (sizeEl && sizeLabel) sizeEl.textContent = "TALLA " + sizeLabel;
    const tags = $("#pdpWaitTags");
    if (tags && sizeLabel) tags.value = `waitlist,waitlist-${waitBox.dataset.handle}-${sizeLabel.trim()}`;
    const input = $('input[type="email"]', waitBox);
    if (input) input.focus();
  }

  sizes.forEach(b => b.addEventListener("click", () => {
    if (b.disabled) return;
    if (b.classList.contains("is-soldout")) { openWaitlist(b.textContent); return; }
    sizes.forEach(x => x.classList.remove("is-active")); b.classList.add("is-active");
    selBtn = b;
    if (variantInput) variantInput.value = b.dataset.variantId;
    const st = parseInt(b.dataset.qty) || 0;
    if (sizeMsg) sizeMsg.innerHTML = st === 1 ? `<b class="warn">¡ÚLTIMA UNIDAD en ${b.textContent}!</b>`
      : (st > 0 && st <= 3) ? `<b class="warn">Solo quedan ${st} en ${b.textContent}</b>`
      : st > 0 ? `Quedan ${st} en talla ${b.textContent}` : "";
    syncQty();
  }));

  const minus = $("#qtyMinus"), plus = $("#qtyPlus");
  if (minus) minus.addEventListener("click", () => { qty--; syncQty(); });
  if (plus) plus.addEventListener("click", () => { qty++; syncQty(); });

  const submit = async e => {
    e.preventDefault();
    if (!selBtn) {
      if (sizeMsg) sizeMsg.innerHTML = `<b class="warn">Elige tu talla primero</b>`;
      const sz = $("#pdpSizes");
      if (sz) { sz.classList.add("shake"); setTimeout(() => sz.classList.remove("shake"), 500); }
      return;
    }
    const ok = await addToCart(variantInput ? variantInput.value : null, qty);
    if (ok) { toast("AÑADIDO AL CARRITO"); setTimeout(openCart, 400); }
  };
  const form = $("#pdpForm");
  if (form) form.addEventListener("submit", submit);

  const sticky = $("#pdpStickyAdd");
  if (sticky) {
    sticky.addEventListener("click", submit);
    addEventListener("scroll", () => {
      const buy = $("#pdpBuy"), st = $("#pdpStickyAdd");
      if (buy && st) st.classList.toggle("is-show", buy.getBoundingClientRect().bottom < 0);
    }, { passive: true });
  }

  const modal = $("#sizeModal");
  const openGuide = $("#openSizeGuide");
  if (modal && openGuide) {
    openGuide.addEventListener("click", () => modal.classList.add("is-open"));
    $$("[data-close-modal]", modal).forEach(el => el.addEventListener("click", () => modal.classList.remove("is-open")));
    addEventListener("keydown", e => { if (e.key === "Escape") modal.classList.remove("is-open"); });
  }
}

/* ---------- ACORDEONES (re-vinculables) ---------- */
function initAccordions(root) {
  $$(".acc__head", root).forEach(h => {
    if (!bindOnce(h, "accBound")) return;
    h.addEventListener("click", () => h.parentElement.classList.toggle("is-open"));
  });
}

/* ---------- PÁGINA DE CARRITO ---------- */
function initCartPage() {
  const note = $("#cartPageShip");
  if (!note || !bindOnce(note, "shipBound")) return;
  fetch(CFG.routes.cart).then(r => r.json()).then(c => {
    if (c.total_price >= FREE) note.innerHTML = "🎉 <b>Tienes envío gratis.</b>";
    else note.innerHTML = `Añade <b>${money(FREE - c.total_price)}</b> más y el envío te sale gratis.`;
  }).catch(() => {});
}

/* ---------- FORMULARIOS DE CAPTURA (AJAX: sin recarga, el éxito siempre se ve) ----------
   Vale para el Nido, la lista de espera del PDP y cualquier futura captura.
   Convención: el form y su mensaje de éxito (.xxx-ok) son hermanos en el mismo contenedor. */
function initSignupForms(root) {
  const forms = [
    { form: "#nidoForm", ok: "#nidoOk", busy: "ENTRANDO…" },
    { form: "#pdpWaitForm", ok: "#pdpWaitOk", busy: "APUNTANDO…" },
    { form: "#nextDropForm", ok: "#nextDropOk", busy: "ENTRANDO…" }
  ];
  forms.forEach(({ form: fs, ok: os, busy }) => {
    const form = $(fs, root) || $(fs);
    if (!form || !bindOnce(form, "signupBound")) return;
    form.addEventListener("submit", async e => {
      e.preventDefault();
      const btn = $("button", form);
      if (btn) { btn.disabled = true; btn.textContent = busy; }
      try {
        await fetch(form.action, { method: "POST", body: new FormData(form) });
      } catch (err) { /* aunque falle la red, no bloqueamos la UX */ }
      form.style.display = "none";
      const ok = $(os);
      if (ok) ok.style.display = "block";
    });
  });
}

/* ================================================================
   INIT GLOBAL + EDITOR DE SHOPIFY
================================================================ */
function initAll(root) {
  const r = root && root.querySelectorAll ? root : document;
  initReveals(r);
  initScramble(r);
  initMagnetic(r);
  initLightbox(r);
  initCards(r);
  initAccordions(r);
  initSignupForms(r);
  initCartUI();
  initHero();
  initCountdown();
  initManifesto();
  initContentReveal();
  initPdp();
  initCartPage();
  lookbookScroll();
}

initAll(document);
fetchCart();

/* cuando el editor re-renderiza una sección, re-inicializamos todo */
document.addEventListener("shopify:section:load", e => {
  /* el PDP y las tarjetas guardan flags en dataset — el DOM nuevo viene limpio, se re-vincula solo */
  initAll(e.target);
});
document.addEventListener("shopify:section:reorder", () => initAll(document));
document.addEventListener("shopify:block:select", e => {
  /* al seleccionar un bloque del hero, muestra esa diapositiva */
  const slide = e.target && e.target.classList && e.target.classList.contains("hero__slide") ? e.target : null;
  if (slide) {
    $$(".hero__slide").forEach(s => s.classList.remove("is-active"));
    slide.classList.add("is-active");
  }
});

})();
